import { TOrganization, TSignInFields, TSignInResponse } from 'shared/types'
import { api } from '../api'

export const login = async (data: TSignInFields) => {
  const userData = await api
    .post<TSignInResponse>('/v1/accounts/sign-in', data)
    .then(({ data }) => data)
  const organization =
    userData.role === 'Admin'
      ? null
      : await api
          .get<TOrganization>('/v1/organization')
          .then(({ data }) => data)

  return { ...userData, organization }
}
